// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"m_-z","subtitle":"n_-z","wrapper":"o_-z","leftArrow":"p_-z","rightArrow":"q_-z"};